export default __webpack_public_path__ + "static/Logo_footer-efb608a9da20239d1e0cbabcf502b264.svg";